
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-rsl",
      function () {
        return require("private-next-pages/about-rsl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-rsl"])
      });
    }
  